import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {createGenerateClassName, createMuiTheme, jssPreset, MuiThemeProvider} from "@material-ui/core";
import JssProvider from "react-jss/lib/JssProvider";
import {create} from "jss";
import rtl from "jss-rtl";

const theme = createMuiTheme({
    direction: 'rtl',
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: "4px",
                marginBottom: "0px",
                width: "180px"
            }
        },
        MuiSelect: {
            root: {
                marginRight: "2px"
            }
        },
        MuiFormHelperText: {
            root: {
                marginTop: "3px",
                marginBottom: "0px"
            }
        },
        MuiInput: {
            root: {
                marginTop: "12px"
            }
        },
        MuiIconButton: {
            root: {
                height: "40px"
            }
        }
    }
});
const jss = create({plugins: [...jssPreset().plugins, rtl()]});
const generateClassName = createGenerateClassName();

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <JssProvider jss={jss}
                     generateClassName={generateClassName}>
            <App/>
        </JssProvider>
    </MuiThemeProvider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js